import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, Fragment } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Typography, Grid, Box, Table, TableRow, TableBody, TableHead, TableContainer, TableCell, Hidden, TextField, } from "@mui/material";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import apiRequest from '../../functions/api';
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import Autocomplete from '@mui/material/Autocomplete';
import openFile from "../shared/functions/download";
import axios from 'axios';
import { API_BASE_URL } from '../../constants/apiConstants';
import { DateTextField, FullPageSpinner } from "../lib";
function A1Certificate(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { accessToken, client, admin } = props;
  const { showErrorMessage, hideMessage } = useMessage();
  let newDate = new Date()
  const [antraege, setAntraege] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [vdat, setVDat] = useState(newDate.getFullYear() + "-" + newDate.getMonth() + "-" + newDate.getDate());
  const [bdat, setBDat] = useState("");
  const [land, setLand] = useState("alle");
  const [an, setAN] = useState("alle");
  const [mitarbeiter, setMitarbeiter] = useState({})
  const [headerfehler, setHeaderfehler] = useState("");
  const [laender, setLaender] = useState({});
  const [sdatei, setSdatei] = useState("");
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      "mandant": client,
      "program": "LA1MAP",
      "start": admin ? "" : "INIT_AN",
      "statement": "HOLE_ANTRAEGE",
      "admin": admin ? "1" : ""
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
    }
    apiRequest('POST', 'daten', payload, headers, datenCb, errorCb);
    // eslint-disable-next-line
  }, [])
  const errorCb = () => {
    setIsLoading(false);
    showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
  }
  const datenCb = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setSdatei(response.data.sdatei && response.data.sdatei)
      if (response.data.antraege) {
        setAntraege(response.data.antraege)
      }
      if (response.data.ab) {
        setVDat(response.data.ab)
      }
      if (response.data.land) {
        setLaender(response.data.land)
      }
      if (response.data.filtermitarbeiter) {
        setMitarbeiter(response.data.filtermitarbeiter)
      }
      if (response.data.header_fehler) {
        setHeaderfehler(response.data.header_fehler)
      }
      setIsLoading(false);
      hideMessage();
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  const setzeLand = (value) => {
    if (!value) {
      setLand("alle")
    } else {
      setLand(value.key)
    }
  }
  const setzeAN = (value) => {
    if (!value) {
      setAN("alle")
    } else {
      setAN(value.key)
    }
  }
  function Infodatei() {
    setShowModal(true)
    const payload = {
      "mandant": client,
      "program": "LA1MAP",
      "start": admin ? "" : "INIT_AN",
      "statement": "INFODATEI",
    }
    const headers = {
      "Authorization": "Bearer " + accessToken,
      "Accept": "application/pdf"
    }
    axios.post(API_BASE_URL + 'daten', payload, { headers: headers, responseType: 'blob' })
      .then((response) => {
        console.log(response);
        var fileName = 'HinweisA1Bescheinigung.pdf';
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setShowModal(false);
      })
      .catch(function (error) {
        console.log(error.response.data)
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
        setShowModal(false);
      })
  }
  if (isLoading) {
    return (<LoadingComponent />)
  }
  const zeichne_filter = () => {
    return (
      <Box p={1}>
        <Typography color="primary">{t("Filter ")}</Typography>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Grid container justifyContent="center" spacing={2} >
              <Grid item xs={12} sm={6} >
                <DateTextField
                  variant="outlined"
                  label={t("Entsendung von")}
                  value={vdat}
                  onChange={(event) => setVDat(event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} >
                <DateTextField
                  variant="outlined"
                  label={t("Entsendung bis")}
                  value={bdat}
                  onChange={(event) => setBDat(event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              {laender.length > 0 &&
                <Grid item xs={12} sm={6} >
                  <Autocomplete
                    noOptionsText={t("kein Eintrag gefunden")}
                    onChange={(event, newValue) => {
                      setzeLand(newValue)
                    }}
                    options={laender}
                    getOptionLabel={(option) => option.bezeichnung}
                    defaultValue={
                      laender.find(element => element.key === land)
                    }
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Land")}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />}
                  />
                </Grid>
              }
              {(mitarbeiter.length > 0 && admin) &&
                <Grid item xs={12} sm={6} >
                  <Autocomplete
                    noOptionsText={t("kein Eintrag gefunden")}
                    onChange={(event, newValue) => {
                      setzeAN(newValue)
                    }}
                    options={mitarbeiter}
                    getOptionLabel={(option) => option.bezeichnung}
                    defaultValue={
                      mitarbeiter.find(element => element.key === an)
                    }
                    renderInput={(params) =>
                      <TextField
                        {...params}
                        label={t("Mitarbeiter")}
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />}
                  />
                </Grid>
              }
            </Grid>
          </Grid>
        </Grid>
      </Box>
    )
  }
  const antraege_zeichnen = (antraege.length > 0) && antraege.map((element) => {
    var datum_von = vdat.replace(/-/g, "");
    var datum_bis = bdat.replace(/-/g, "");
    if (datum_von > element.bdat) {
      return ("")
    }
    if (datum_bis && datum_bis < element.bdat) {
      return ("")
    }
    if (land !== "alle" && land !== element.landkey) {
      return ("")
    }
    if (an !== "alle" && an !== element.ankey) {
      return ("")
    }
    return (
      <Fragment>
        <Hidden mdDown>
          <TableRow style={{ cursor: 'pointer' }} onClick={() => admin ? navigate("/LA1MAP/edit/" + element.key) : navigate("/LA1MAP-INIT_AN/edit/" + element.key)} >
            <TableCell>{element.an}</TableCell>
            <TableCell>{element.art}</TableCell>
            <TableCell>{element.land}</TableCell>
            <TableCell>{element.stelle}</TableCell>
            <TableCell>{element.zeitraum}</TableCell>
            <TableCell style={{ color: "rgb(" + element.farbe + ")" }} >{element.status}</TableCell>
          </TableRow>
        </Hidden>
        <Hidden smUp>
          <TableRow onClick={() => admin ? navigate("/LA1MAP/edit/" + element.key) : navigate("/LA1MAP-INIT_AN/edit/" + element.key)} >
            <TableCell>
              <Typography style={{ backgroundColor: "rgb(" + element.farbe + ")" }} >{element.status}</Typography>
              <Typography>{element.an}</Typography>
              <Typography>{element.art}</Typography>
              <Typography>{element.land}</Typography>
              <Typography>{element.stelle}</Typography>
              <Typography>{element.zeitraum}</Typography>
            </TableCell>
          </TableRow>
        </Hidden>
      </Fragment>
    )
  })
  return (
    <Page>
      <Layout>
        {(admin || headerfehler !== "1") ?
          <Grid container justifyContent="center">
            <Grid item xs={12}>
              <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} sm={6}>
                  <Box p={2}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={() => admin ? navigate("/LA1MAP/new") : navigate("/LA1MAP-INIT_AN/new")}
                    >{t("Neue Bescheinigung erstellen")}</Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            {(sdatei && sdatei === "1") &&
              <Grid item xs={12}>
                <Grid container spacing={2} justifyContent="center">
                  <Grid item xs={12} sm={6}>
                    <Box p={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => Infodatei()}
                      >{t("Hinweis ihres Arbeitgebers zur A1-Bescheinigung anzeigen")}</Button>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            }
          </Grid>
          :
          <Grid container justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Box p={2}>
                <Typography>{t(" Es wurden noch nicht alle Arbeitgebervorgaben vorgegeben! Bitte wenden Sie sich an Ihren Vorgesetzten um einen A1-Antrag erstellen zu können.")}</Typography>
              </Box>
            </Grid>
          </Grid>
        }
        <Box pl={2} pr={2} pt={1} pb={1}>
          <Typography variant="h6">{t("Übersicht aller A1-Bescheinigungen")}</Typography>
        </Box>
        {antraege.length > 0 && zeichne_filter()}
        {
          antraege.length > 0 ?
            <TableContainer>
              <Table>
                <Hidden mdDown>
                  <TableHead>
                    <TableRow>
                      <TableCell>{t("Arbeitnehmer")}</TableCell>
                      <TableCell>{t("Art")}</TableCell>
                      <TableCell>{t("Entsendungsstaat")}</TableCell>
                      <TableCell>{t("Beschäftigungsstelle")}</TableCell>
                      <TableCell>{t("Aufenthaltszeitraum")}</TableCell>
                      <TableCell>{t("Status")}</TableCell>
                    </TableRow>
                  </TableHead>
                </Hidden>
                <TableBody>
                  {antraege_zeichnen}
                </TableBody>
              </Table>
            </TableContainer>
            :
            <Typography>{t("Sie haben bisher noch keine A1-Bescheinigungen beantragt")}</Typography>
        }
      </Layout>
      {(showModal) && <FullPageSpinner />}
    </Page>
  )
}
export default A1Certificate;
